import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";

const About = lazy(() => import("@/pages/About"));
const Approach = lazy(() => import("@/pages/Approach"));
const Operations = lazy(() => import("@/pages/Operations"));
const Portfolio = lazy(() => import("@/pages/Portfolio"));
const Leadership = lazy(() => import("@/pages/Leadership"));
const WhyPartner = lazy(() => import("@/pages/WhyPartner"));
const Contact = lazy(() => import("@/pages/Contact"));
const Careers = lazy(() => import("@/pages/Careers"));
const Admin = lazy(() => import("@/pages/Admin"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Fallback = () => <div className="min-h-screen bg-navy" />;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <main>
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/operations" element={<Operations />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/why-partner" element={<WhyPartner />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <Toaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
